import { Sparkle } from "lucide-react";

// Slow editorial marquee — CSS animated, duplicated track for seamless loop
export const Marquee = ({ words }) => {
  const track = [...words, ...words];
  return (
    <div className="relative overflow-hidden border-y border-slate-200 bg-white py-6" data-testid="marquee">
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {track.map((w, i) => (
          <span key={i} className="mx-8 inline-flex items-center gap-8 text-2xl font-semibold text-slate-900 md:text-3xl">
            <span className="font-[Outfit]">{w}</span>
            <Sparkle className="h-4 w-4 text-[color:var(--brand-red)]" strokeWidth={2} />
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
